<template>
  <div id="popupModal">
    <div class="popupModalBody">
      <div id="close" @click="onClickClosePopup">
        <font-awesome-icon icon="times" />
      </div>
      <div class="popupModalTitle">Terms & Conditions</div>
      <div class="popupModalDescription">
        I understand everything I enter (including audio recordings) may be added to the VIR Museum Archives and made available in accordance with the policies of the Archives and in respect to all legal and records management policies and use guidelines. I hereby grant VIR the right to record my name and story including my voice. I grant, assign, and transfer to VIR all right, title and interest to any original story, materials or recordings I submit and the resulting rights, effective from the moment of creation for use in any and all media throughout the world, now known or later developed. I also grant VIR the right to use my name in connection with any materials I submit. I hereby release and discharge VIR and its agents, subsidiaries, affiliates, officers, employees, successors and assigns from any and all claims, actions and demands arising out of or in connection with the use of materials submitted. 
      </div>
      <div class="popupModalFooter">
        <div class="checkbox">
          <div class="checkboxCol">
            <input
              type="checkbox"
              name="agreeToTerm"
              value="agreed to term"
              v-model="agreedTerm"
            />
            <span>I agree to the above terms & conditions.</span>
          </div>
        </div>
        <button @click="termsAndConditionContinue">Continue</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["settings"],
  data() {
    return {
      agreedTerm: null
    };
  },
  methods: {
    termsAndConditionContinue(){
      if(!this.agreedTerm){
        this.$swal("Error!", "Please complete all required fields", "error");
        return;
      }
      this.$store.state.user.user.agreedTerm = this.agreedTerm
      this.$emit("changePasswordStatus", true);
    },
    onClickClosePopup() {
      this.$store.state.user.user.agreedTerm = null;
      this.$emit("changePasswordStatus", false);
    },
    async handleUserChange(newVal) {
      let userId = newVal.id;
      window.console.log("newVal.isActive", newVal.isActive);

      const updateTopicUserStatusRes = await axios.post(
        `admin/updateTopicUserStatus`,
        {
          topic: this.userModalProps,
          user_id: userId,
          active: newVal.isActive,
        }
      );
    },
    async init() {
      try {
        //const getUsersRes = await axios.get(`admin/getUsers`);
        //this.users = getUsersRes.data;
        //this.users.forEach(user => {
        //   this.$set(user, 'isActive', false)
        //});
        //const getUsersByTopicIdRes = await axios.get(`admin/getUsersByTopicId/${this.userModalProps}`);
        //getUsersByTopicIdRes.data.forEach(TopicUser => {
        //    let user = this.users.find(user => user.id == TopicUser.userId)
        //    user.isActive = TopicUser.isActive;
        //});
        //window.console.log(this.users);
        //this.users.forEach((val) => {
        //    this.$watch(() => val, this.handleUserChange, {deep: true});
        //});
      } catch (e) {
        window.console.log(e);
      }
      this.isLoading = false;
    },
  },
  mounted() {},
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
#popupModal {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  #close {
    background: #ff6262;
    border-radius: 4px 4px 0 0;
    width: 37px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 18px;
    bottom: 100%;
    cursor: pointer;

    svg {
      color: #ffffff;
      font-size: 23px;
    }
  }
  .checkbox {
    .checkboxCol {
      display: flex;
      align-items: center;
      input {
        height: auto;
      }
      margin-left: 30px;
      &:first-child {
        margin-left: 0px;
      }
      span {
        font-family: Effra-Medium;
        font-size: 13px;
        color: #000000;
        letter-spacing: 0;
        margin-left: 13px;
      }
    }
    .checkboxCol {
      display: inline-flex;
      cursor: pointer;
      position: relative;
      & > span {
        //color: #3d3d3d;
        padding: 0.5rem 0.25rem;
      }
      & > input {
        height: 25px;
        width: 25px;
        appearance: none;
        border: 1px solid #009AD6;
        border-radius: 4px;
        outline: none;
        transition-duration: 0.3s;
        background-color: #ffffff;
        cursor: pointer;
      }
      & > input:checked {
        border: 1px solid #ffffff;
        background-color: #009AD6;
        border-radius: 50%;
      }

      & > input:checked + span::before {
        content: "\2713";
        display: block;
        text-align: center;
        color: #ffffff;
        position: absolute;
        left: 8px;
        top: 9px;
        pointer-events: none;
      }

      & > input:active {
        border: 2px solid #3d3d3d;
      }
    }
  }
  .popupModalBody{
    background-image: linear-gradient(180deg, #F6F6F6 0%, #FFFFFF 100%);
    box-shadow: 0 4px 67px 0 rgba(0,0,0,0.13);
    border-radius: 8px;
    max-width: 733px;
    padding: 50px;
    position: relative;
    .popupModalTitle{
      font-family: Effra-Light;
      font-size: 30px;
      color: #009AD6;
      letter-spacing: 0;
      line-height: 44px;
      margin-bottom: 13px;
    }
    .popupModalDescription{
      font-family: Effra-Regular;
      font-size: 13px;
      color: #5F5F5F;
      letter-spacing: 0;
      line-height: 19px;
    }
  }
  .popupModalFooter{
    display: flex;
    border-top: 2px solid #009AD6;
    margin-top: 20px;
    padding-top: 25px;
    align-items: center;
    justify-content: space-between;
  }
  button{
    background: #009AD6;
    border-radius: 4px;
    font-family: Effra-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 23px;
    padding: 4px 36px;
    border: 0;
  }
}
</style>